
namespace Gamification.Gamification {

    export interface AssetEsperienzePickerOptions {
        hideAssetEsperienze?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeCheckGrid extends Serenity.EntityGrid<AssetEsperienzeRow, AssetEsperienzePickerOptions> {
        protected getColumnsKey() { return AssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return AssetEsperienzeDialog; }
        protected getIdProperty() { return AssetEsperienzeRow.idProperty; }
        protected getLocalTextPrefix() { return AssetEsperienzeRow.localTextPrefix; }
        protected getService() { return AssetEsperienzeService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: AssetEsperienzePickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            if (this.options.hideAssetEsperienze && this.options.hideAssetEsperienze.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.AssetEsperienzeRow.Fields.IdAssetEsperienza], 'not in', [this.options.hideAssetEsperienze]], request.Criteria);
            }

            return true;
        }
    }
}